export const iconFontAwesomeTextformattingTable = (
	<i className="fa-solid fa-table"></i>
);
